export default __webpack_public_path__ + "static/media/1.dc05408e.jpg";